import axios from 'axios';
import { IPhysician } from 'app/models/physicians.models';

const basePath = '/physicians';

export const physicianService = {
  getPhysicianCollecton: (): Promise<IPhysician[]> => axios.get(`${basePath}`),
};
